import { PageAction } from './';

export class PageInfo {
    public pageNumber: number = 0;
    public pageReady: boolean = false;
    public pageStyles: string = '';
    public pageContent: string = '';
    public pageActions: PageAction[] = [];
}
